import { Navigate, Route, Routes } from "react-router-dom";
//utils
import { isAuthenticated } from "../utils/auth";
//pages
import Leads from "../pages/Crm/Leads/Leads";
import Queue from "../pages/Crm/Settings/Queue";
import Funnel from "../pages/Crm/Funnel/Funnel";
import Origins from "../pages/Crm/Settings/Origins";
import ActicveAds from "../pages/Crm/Ads/ActiveAds";
import StatusConfig from "../pages/Crm/Settings/Status/StatusConfig";
import AdsDashboard from "../pages/Crm/Ads/AdsDashboard";
import { FormLeadConfig } from "../pages/Crm/Settings/FormLeadConfig";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const CrmRoute = () => (
  <PrivateRoute>
    <Routes>
      <Route path="/funnel" element={<Funnel />} />
      <Route path="/leads" element={<Leads />} />
      <Route path="/ads/active" element={<ActicveAds />} />
      <Route path="/ads/dashboard" element={<AdsDashboard />} />
      <Route path="/settings/status" element={<StatusConfig />} />
      <Route path="/settings/origins" element={<Origins />} />
      <Route path="/settings/queue" element={<Queue />} />
      <Route path="/settings/formLead" element={<FormLeadConfig />} />
    </Routes>
  </PrivateRoute>
);
